import defaultSettings from '@/utils/settings'

const title = defaultSettings.title;

export default function setTitle(pageTitle) {
    if (pageTitle) {
        return `${title}-${pageTitle}`
    }
    return `${title}`
}
